import script from "./AdminMaterialsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminMaterialsView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminMaterialsView.vue?vue&type=style&index=0&id=1c385ae7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c385ae7"]])

export default __exports__